import { RESOURCE_KEYS } from '../constants/resourceKeys';
import { createResourceStats } from '../factory/resourceStatsFactory';
import type { Settlement } from '../types';

export function ensureResourceStatsWindow(settlement: Settlement, window: number): void {
    if (settlement.resourceStats && settlement.resourceStats.window === window) return;
    settlement.resourceStats = createResourceStats(window);
}

export function advanceResourceStatsTick(
    settlement: Settlement,
    window: number,
    tickIndex: number,
): void {
    ensureResourceStatsWindow(settlement, window);
    const stats = settlement.resourceStats;
    if (stats.tick === tickIndex) return;
    stats.tick = tickIndex;
    stats.index = (stats.index + 1) % stats.window;
    RESOURCE_KEYS.forEach((key) => {
        stats.produced[key][stats.index] = 0;
        stats.consumed[key][stats.index] = 0;
    });
}
